import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ApiListingResponse } from '@app/shared/models';
import { Product, ProductDto } from '@app/store/models';
import { map } from 'rxjs';
import { ProductsValueDto } from '../models/products.value.dto';
import { ProductsValue } from '../models/products.value';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    private readonly httpClient = inject(HttpClient);

    getProducts(params: ProductsValue) {
        return this.httpClient
            .addAllSwitches()
            .get<ApiListingResponse<ProductDto[]>>(`api/v1/items`, { params: new ProductsValueDto(params).params })
            .pipe(
                map((response) => ({
                    items: response.data.map((productDto) => new Product(productDto)),
                    totalItems: response.pagination.totalItems,
                })),
            );
    }
}
